import { render } from "./FlagIcon.vue?vue&type=template&id=56a580e2"
const script = {}
script.render = render

export default script